var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7579 10.5108H7.24042C6.89542 10.5108 6.61542 10.2308 6.61542 9.88584C6.61542 9.54084 6.89542 9.26084 7.24042 9.26084H12.7579C13.1029 9.26084 13.3829 9.54084 13.3829 9.88584C13.3829 10.2308 13.1029 10.5108 12.7579 10.5108ZM12.7579 13.8908H7.24042C6.89542 13.8908 6.61542 13.6108 6.61542 13.2658C6.61542 12.9208 6.89542 12.6408 7.24042 12.6408H12.7579C13.1029 12.6408 13.3829 12.9208 13.3829 13.2658C13.3829 13.6108 13.1029 13.8908 12.7579 13.8908ZM7.24126 5.88834H9.34625C9.69125 5.88834 9.97125 6.16834 9.97125 6.51334C9.97125 6.85834 9.69125 7.13834 9.34625 7.13834H7.24126C6.89626 7.13834 6.61625 6.85834 6.61625 6.51334C6.61625 6.16834 6.89626 5.88834 7.24126 5.88834ZM13.3637 2.08334H6.63542C4.51292 2.08334 2.78625 3.81001 2.78625 5.93334V14.0667C2.78625 16.1892 4.51292 17.9167 6.63542 17.9167H13.3637C15.4862 17.9167 17.2137 16.1892 17.2137 14.0667V5.93334C17.2137 3.81001 15.4862 2.08334 13.3637 2.08334Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.7a7bd565cd20083b614b5b5bdc3e1e93.svg";
export { ForwardRef as ReactComponent };